import { ArrowUp } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

const LINKS = [
  { label: "About", target: "#about" },
  { label: "Products", target: "#products" },
  { label: "Services", target: "#services" },
  { label: "Contact", target: "#contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative overflow-hidden bg-ink text-white"
    >
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8 lg:pt-28">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <LogoLockup dark />
            <p className="mt-6 max-w-sm font-heading text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl">
              Nothing Missed.{" "}
              <span className="text-brand">Nothing Broken.</span>
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Software engineering and IT consulting for enterprises that
              cannot afford surprises.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.label}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => scrollToSection(l.target)}
                    className="text-sm text-slate-300 transition-colors hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
              Reach us
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li>
                <a href="mailto:info@jisll.com" className="transition-colors hover:text-white" data-testid="footer-link-email">
                  info@jisll.com
                </a>
              </li>
              <li>
                <a href="tel:+919486260638" className="transition-colors hover:text-white" data-testid="footer-link-phone">
                  +91 94862 60638
                </a>
              </li>
              <li className="leading-relaxed text-slate-400">
                78, 1st Floor, 2nd Main Road, M M Nagar,
                <br />
                Trichy - 620017, India
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-slate-500">
            © {new Date().getFullYear()} JISLL Technology Services Pvt Ltd. All rights reserved.
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={scrollToTop}
            className="group flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300 transition-all duration-200 hover:border-brand hover:bg-brand hover:text-white"
            aria-label="Back to top"
          >
            Back to top
            <ArrowUp className="h-3.5 w-3.5 transition-transform duration-200 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="pointer-events-none select-none text-center font-heading text-[clamp(6rem,20vw,17rem)] font-black leading-[0.78] tracking-tight text-white/[0.04]"
      >
        JISLL
      </div>
    </footer>
  );
}
